import _ from 'es-toolkit/compat';
export const buildUrlHref = (origin, path) => {
    return new URL(path, origin).href;
};
export const buildUrl = (appUrl, urlPath, pathParams, queryParams) => {
    const generatedPath = generatePath(urlPath, pathParams);
    const params = new URLSearchParams(queryParams);
    const finalUrlPath = `${generatedPath}${_.isEmpty(queryParams) ? '' : `?${params.toString()}`}`;
    return buildUrlHref(appUrl, finalUrlPath);
};
export const getThirdPartyRequestsLink = (appUrl, urlPath) => {
    return buildUrl(appUrl, urlPath);
};
function generatePath(originalPath, params) {
    if (!params)
        return originalPath;
    const path = originalPath;
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith('/') ? '/' : '';
    const segments = path
        .split(/\/+/)
        .map(segment => {
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key] = keyMatch;
            if (!key)
                return segment;
            const param = params[key];
            return param;
        }
        return segment;
    })
        // Remove empty segments
        .filter(segment => !!segment);
    return prefix + segments.join('/');
}
//# sourceMappingURL=buildUrl.js.map